import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const Messages = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/";
	const success = {
		title: "PROFORUM Membership Registration",
		message: "Application successfully submitted for processing",
	};

	const handleOk = () => {
		navigate(from, { replace: true });
	};

	const SuccessMessage = (
		<div className="msgs">
			<h1 className="msg-title">{success.title}</h1>
			<div className="msg-image">
				<img src="/images/logos/check.png" alt="PROFORUM" />
			</div>
			<h3 className="msg-text">{success.message}</h3>
			<hr />

		
				<button
					type="button"
					onClick={handleOk}
					className="btn btn-success btn-block"
				>
					Ok
				</button>
			
		</div>
	);
	return (
		<>
			<section className="content-header">
				<h1>PROFORUM Membership Application</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											Successful Application
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{SuccessMessage}</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
